import { render, staticRenderFns } from "./ImportTask.vue?vue&type=template&id=2f65a7c4&scoped=true"
import script from "./ImportTask.vue?vue&type=script&lang=js"
export * from "./ImportTask.vue?vue&type=script&lang=js"
import style0 from "./ImportTask.vue?vue&type=style&index=0&id=2f65a7c4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f65a7c4",
  null
  
)

export default component.exports